import { render, staticRenderFns } from "./ConfigureAndPublish.vue?vue&type=template&id=6ccf947e&"
import script from "./ConfigureAndPublish.vue?vue&type=script&lang=js&"
export * from "./ConfigureAndPublish.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureAndPublish.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ConfigureAndPublish.vue"
export default component.exports